// extracted by mini-css-extract-plugin
export default {"propertiesInfo":"PropertiesInfo_propertiesInfo__8+b0P","divCards":"PropertiesInfo_divCards__LRW4V"};